document.addEventListener('DOMContentLoaded', function () {
  // Intercept submit on capture so we can override the flow
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Only act on product add-to-cart forms
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;

    // Check if this form has warranty radios
    const selectedWarranty = form.querySelector('input[name="extended_warranty"]:checked');
    if (!selectedWarranty) {
      // No warranty UI on this form — let the theme handle everything
      return;
    }

    const choice = selectedWarranty.value;

    // If customer keeps "1-year warranty (Included)", do not interfere
    if (!choice || choice === 'none') {
      return;
    }

    // From here: 2yr or 3yr selected — we take over
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    // IMPORTANT: read using getAttribute, NOT dataset
    const warranty2yrId = form.getAttribute('data-warranty-2yr-id');
    const warranty3yrId = form.getAttribute('data-warranty-3yr-id');

    let warrantyVariantId = null;
    if (choice === '2yr') {
      warrantyVariantId = warranty2yrId;
    } else if (choice === '3yr') {
      warrantyVariantId = warranty3yrId;
    }

    if (!warrantyVariantId) {
      console.warn('Warranty option selected but no variant id configured', {
        choice,
        warranty2yrId,
        warranty3yrId
      });

      // Fallback: let the form submit normally (no warranty)
      form.submit();
      return;
    }

    // Main product variant + quantity
    const variantInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');

    const mainVariantId = variantInput ? Number(variantInput.value) : null;

    let quantity = 1;
    if (quantityInput) {
      const parsed = parseInt(quantityInput.value, 10);
      if (!Number.isNaN(parsed) && parsed > 0) {
        quantity = parsed;
      }
    }

    if (!mainVariantId) {
      console.warn('Cannot find main product variant id on form, falling back to normal submit');
      form.submit();
      return;
    }

    // Loading state on button
    const submitButton = form.querySelector('.product-form__submit');
    const spinner = submitButton && submitButton.querySelector('.loading-overlay__spinner');

    function setLoading(isLoading) {
      if (!submitButton) return;
      if (isLoading) {
        submitButton.disabled = true;
        if (spinner) spinner.classList.remove('hidden');
      } else {
        submitButton.disabled = false;
        if (spinner) spinner.classList.add('hidden');
      }
    }

    setLoading(true);

    // Single /cart/add.js payload: product + warranty
    const payload = {
      items: [
        {
          id: mainVariantId,
          quantity: quantity
        },
        {
          id: Number(warrantyVariantId),
          quantity: quantity,
          properties: {
            _warranty_for: 'SmartSlydr'
          }
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) {
          return res
            .json()
            .catch(function () { return {}; })
            .then(function (json) {
              const message = json && json.description ? json.description : 'Unknown error';
              throw new Error('Cart add error: ' + message);
            });
        }
        return res.json();
      })
      .then(function () {
        // Success: take customer to cart where both items are visible
        window.location.href = '/cart';
      })
      .catch(function (error) {
        console.error('Error adding product + warranty, falling back to simple form submit:', error);
        setLoading(false);
        try {
          form.submit();
        } catch (e) {
          console.error('Fallback form.submit() failed', e);
        }
      });
  }, true); // capture = true
});
